// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__3tr9f","label":"ToggleSwitch_label__pLsOR","input":"ToggleSwitch_input__1MUWo","track":"ToggleSwitch_track__A6Rnq","thumb":"ToggleSwitch_thumb__mjrgf"};